/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ModerationActionsContainer_viewer = {
    readonly id: string;
    readonly " $refType": "ModerationActionsContainer_viewer";
};
export type ModerationActionsContainer_viewer$data = ModerationActionsContainer_viewer;
export type ModerationActionsContainer_viewer$key = {
    readonly " $data"?: ModerationActionsContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"ModerationActionsContainer_viewer">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ModerationActionsContainer_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        }
    ],
    "type": "User",
    "abstractKey": null
} as any);
(node as any).hash = '4395964e5e58b6f5f1741f91431658bf';
export default node;
